import { of as observableOf, Observable} from 'rxjs';
import { map } from "rxjs/operators";
import {EventEmitter, Injectable, OnInit} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { RaceViewModel } from "../system/races/Model/RaceViewModel";
import { SharedObjectModel } from "../system/races/Model/SharedObjectModel";
import { ShareObjectViewModel } from "./IOwnerManipulationService";
import { IManagableObject } from "../system/admin-panel/IManagableObject";
import { GapViewModel } from '../system/races/Model/GapViewModel';

@Injectable()
export class RacesService implements OnInit {

  public onInit = new EventEmitter<RaceViewModel>();

  constructor(private client: HttpClient)
  {
  }

  public get(from: number, till: number): Observable<RaceViewModel[]>
  {
    return this.client.post<any>("/ctrl/activity", { from: from, till: till}).pipe(map(values =>
    {
      let result = [];
      if (values && values.constructor === Array)
        for (let item of values)
        {
            var race = RaceViewModel.fromJS(item);
            result.push(race);
        }
      result.sort((a: RaceViewModel, b: RaceViewModel) => {return a.From - b.From});
      return result;
    }));
  }

  public delete(id: number) {
    return this.client.delete("/ctrl/activity/" + id);
  }

  public update(obj: RaceViewModel) {
    return this.client.put("/ctrl/activity", obj);
  }

  public getLinkedObjects(id: number) {
    return this.client.get<any>("/ctrl/activity/objects/" + id).pipe(map(values =>
    {
      let result = [];
      if (values && values.constructor === Array)
        for (let item of values)
        {
          var race = SharedObjectModel.fromJS(item);
          result.push(race);
        }
      return result;
    }));
  }
  public updateLinkedObjects(id: number, objects: IManagableObject[])
  {
    var arr: number[] = [];
    for (var i = 0; i < objects.length; i++)
      if (objects[i].IsChecked)
        arr.push(objects[i].Id);
    return this.client.put("/ctrl/activity/objects", new ShareObjectViewModel(0, id, arr));
  }

  ngOnInit(): void {

  }
  public getGap(GapDate: number): Observable<GapViewModel[]> {
    return this.client.get<any>("/ctrl/activity/gap/" + GapDate).pipe(map(values => {
      let result = [];
      if (values && values.constructor === Array)
        for (let item of values) {
          var race = GapViewModel.fromJS(item);
          result.push(race);
        }
      result.sort((a: GapViewModel, b: GapViewModel) => { return a.TimeGap - b.TimeGap });
      return result;
    }));
  }
}
